const custom = {
  root: {
    color: '#2898ff',
  },
};

export default custom;
